module.exports = __webpack_public_path__ + "img/stage-1-motion.73b6e430.png";